export const EXCEPTION_EVALUATION_ITEM_TITLES = {
  financials: 'Valor excepcional',
  repassMode: 'Modalidade de repasse',
  proportionalityRule: 'Regra de proporcionalidade',
  workJourney: 'Jornada de trabalho'
} as const

export interface JustificationItem {
  title?: string
  text: string
}

export type JustificationItemStatus = 'approved' | 'rejected' | null

const ITEM_STATUS_LABELS = {
  approved: 'aprovado',
  rejected: 'recusado'
} as const

const ITEM_SEPARATOR = '; '

const ITEM_PREFIX_PATTERN = new RegExp(
  `(?:^|${ITEM_SEPARATOR})((?:${Object.values(EXCEPTION_EVALUATION_ITEM_TITLES).join('|')})` +
    `(?: \\((?:${Object.values(ITEM_STATUS_LABELS).join('|')})\\))?): `,
  'g'
)

// O título leva o status do item ("Valor excepcional (aprovado): …"); sem status, sai sem marcação.
export function buildDecisionJustification(
  items: { title: string; text: string; status?: JustificationItemStatus }[]
): string {
  return items
    .filter((item) => item.text)
    .map((item) => {
      const tag = item.status ? ` (${ITEM_STATUS_LABELS[item.status]})` : ''
      return `${item.title}${tag}: ${item.text}`
    })
    .join(ITEM_SEPARATOR)
}

// Só reconhece os títulos conhecidos (com ou sem marcação de status): um "; " ou ":" digitado no
// meio do texto não quebra o item. Strings antigas, sem marcação, continuam sendo lidas.
export function parseDecisionJustification(raw: string | null | undefined): JustificationItem[] {
  const text = raw?.trim()
  if (!text) return []

  const matches = [...text.matchAll(ITEM_PREFIX_PATTERN)]
  if (matches.length === 0 || matches[0].index !== 0) return [{ text }]

  return matches
    .map((match, i) => {
      const start = match.index! + match[0].length
      const end = i + 1 < matches.length ? matches[i + 1].index! : text.length
      return { title: match[1], text: text.slice(start, end).trim() }
    })
    .filter((item) => item.text)
}
